var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEc2Instance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.688 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.344,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.727C0 9.441 5.756 3.576 12.906 3.576h49.189C69.244 3.576 75 9.441 75 16.727v50.123C75 74.135 69.244 80 62.094 80H12.906C5.756 80 0 74.135 0 66.849z",
    fill: "#9d5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.151C0 5.865 5.756 0 12.906 0h49.189C69.244 0 75 5.865 75 13.151v50.123c0 7.286-5.756 13.151-12.906 13.151H12.906C5.756 76.424 0 70.559 0 63.273z",
    fill: "#f58536"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc2Instance);
export default __webpack_public_path__ + "static/media/ec2-instance.c479bcdbb505e063cd0b7b7100f8aab1.svg";
export { ForwardRef as ReactComponent };